import { render, staticRenderFns } from "./ownerDetailAccessControlRecord.vue?vue&type=template&id=0e564580"
import script from "./ownerDetailAccessControlRecord.vue?vue&type=script&lang=js"
export * from "./ownerDetailAccessControlRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports